/* src/app/support/alarm-list/alarm-list.component.css */
.alarm-list {
}
.alarm-summary {
}
.alarm-message-row {
}
.alert-list {
  list-style: none;
  padding: 0;
  margin: 20px;
  max-width: 1000px;
}
.alert-list li {
  margin-bottom: 18px;
  padding: 16px 18px 14px 18px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
  display: flex;
  flex-direction: column;
  position: relative;
  border-left: 6px solid #ccc;
  transition: border-color 0.2s, background 0.2s;
}
.alert-list li.firing {
  border-left-color: #e53935;
  background: #fff5f5;
}
.alert-list li.resolved {
  border-left-color: #43a047;
  background: #f5fff5;
}
.alert-title {
  font-weight: 600;
  font-size: 1.15em;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
}
.alert-icon {
  margin-right: 8px;
}
.alert-description {
  margin-bottom: 6px;
  font-size: 1.2em;
  color: #444;
}
.alert-meta {
  font-size: 0.95em;
  color: #888;
  margin-bottom: 6px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.alert-labels {
  list-style: none;
  padding: 0;
  margin: 0 0 6px 0;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.alert-labels li {
  background: #f3f3f3;
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 0.95em;
}
button[mat-icon-button] {
  position: absolute;
  top: 12px;
  right: 12px;
}
/*# sourceMappingURL=alarm-list.component.css.map */
